/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MMLeaderboardResult_getLeaderboardPositions$ref: FragmentReference;
declare export opaque type MMLeaderboardResult_getLeaderboardPositions$fragmentType: MMLeaderboardResult_getLeaderboardPositions$ref;
export type MMLeaderboardResult_getLeaderboardPositions = {|
  +getLeaderboardPositions: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?$ReadOnlyArray<?{|
      +points: ?number,
      +position: ?string,
      +guest: ?{|
        +guest_name: ?string,
        +guest_title: ?string,
      |},
    |}>,
    +max_page: ?number,
  |},
  +$refType: MMLeaderboardResult_getLeaderboardPositions$ref,
|};
export type MMLeaderboardResult_getLeaderboardPositions$data = MMLeaderboardResult_getLeaderboardPositions;
export type MMLeaderboardResult_getLeaderboardPositions$key = {
  +$data?: MMLeaderboardResult_getLeaderboardPositions$data,
  +$fragmentRefs: MMLeaderboardResult_getLeaderboardPositions$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "MMLeaderboardResult_getLeaderboardPositions",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "event_id",
      "type": "Int!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "segment_id",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "page_number",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "rec_per_page",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "searchInput",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "getLeaderboardPositions",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "event_id",
          "variableName": "event_id"
        },
        {
          "kind": "Variable",
          "name": "page_number",
          "variableName": "page_number"
        },
        {
          "kind": "Variable",
          "name": "rec_per_page",
          "variableName": "rec_per_page"
        },
        {
          "kind": "Variable",
          "name": "searchInput",
          "variableName": "searchInput"
        },
        {
          "kind": "Variable",
          "name": "segment_id",
          "variableName": "segment_id"
        }
      ],
      "concreteType": "leaderboard_positions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "message",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "data",
          "storageKey": null,
          "args": null,
          "concreteType": "positions",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "points",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "position",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "guest",
              "storageKey": null,
              "args": null,
              "concreteType": "front_inner_events_guest",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "guest_name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "guest_title",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "max_page",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a2c9c41ff041ef51d7c8e88eb8ea086d';
module.exports = node;
